<template>
    <div style="width: 500px;">
    <b-form-select v-model="type" :options="options"></b-form-select>
    <!-- <b-form-checkbox
        id="checkbox-1"
        v-model="selected"
        :value="true"
        :unchecked-value="false"
        >series-3</b-form-checkbox
    > -->
    <b-form-checkbox
        id="checkbox-2"
        v-model="dataLabels"
        :value="true"
        :unchecked-value="false"
        >顯示數值標籤</b-form-checkbox
    >
    <apexchart ref="chart1ref" width="500" :type="type" :options="chartOptions" :series="series"></apexchart>
    <div>
        <apexchart type="pie" width="380" :options="chartOptions1" :series="series1"></apexchart>
    </div>
    </div>
    
</template>
<script>
export default {
    data: function() {
    return {
        type:'line',
        series1: [12, 22, 43, 25, 22],
        dataLabels:false,
        chartOptions1: {
            chart: {
            width: 380,
            type: 'pie',
            },
            title: { //設定圖表標題，可不設定(即無標題)
                text: '年齡分佈',
                align: 'center' //設定標題位置，預設為left
            },
            labels: ['0-15歲', '16-25歲', '26-40歲', '40-55歲', '55歲以上'],
            responsive: [{
                breakpoint: 480,
                options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
                }
            }]
        },
        chartOptions: {
            chart: {
                id: 'vuechart-example',
                //stacked: false
            },
            title: { //設定圖表標題，可不設定(即無標題)
                text: '人數統計',
                align: 'center' //設定標題位置，預設為left
            },
            dataLabels: { //是否在圖表中顯示數值標籤
                enabled: false,
            },
            stroke: { //設定線條格式[只限line & Area模式]
                width: [1, 3], //路徑寬度
                curve: 'smooth', //路徑平滑
                dashArray: [0, 15] //線變為破折號，數值越大破折號越大 [預設為0(即直線)]
            },
            xaxis: {
                categories: [2015, 2016, 2017, 2018, 2019, 2020, 2021,],
                title: {
                    text: 'year'
                },
            },
            grid: { //設定背景網格樣式
                //show : false, //是否顯示背景網格[預設為true]
                padding: { //設定網格位置
                    right: 0,
                    left: 10,
                },
            },
            //labels: ['Apples', 'Oranges', 'Berries', 'Grapes','Apples', 'Oranges', 'Berries', 'Grapes'], //設定x軸的標名，只接受list型態，跟xaxis擇一使用
            legend: { //設定圖例
                //show: false //是否顯示圖例，預設為顯示
                markers: {
                    //radius:0, //圖例圖片圓弧角度 (預設為2)
                    strokeWidth:0,
                    customHTML: function() {
                    return '<span class="custom-marker"><i class="fas fa-chart-pie"></i></span>'
                    }
                },
                onItemClick:{
                    toggleDataSeries: true //轉換成滑鼠鼠標移動到該圖例後，focused該圖例資料 [預設為false，需用滑鼠點擊才可有該效果]
                }
            }
        },
        series: [
            {
                name: 'series-1',
                data: [30, 40, 35, 50, 49, 60, 70],
            },
            {
                name: 'series-2',
                data: [20, 50, 45, 25, 13, 26, 80]
            },
            {
                name:'series-3',
                data: [66, 25, 70, 25, 10, 13, 65]
            },
        ],
        options: [
            { value: 'line', text: 'line' },
            { value: 'bar', text: 'bar' },
            { value: 'area', text: 'area' },
        ],
        selected : true
        }
    },
    watch: {
        "type"(val){
            console.log("type is changed",val);
            this.$refs.chart1ref.hideSeries('series-3');
        },
        "selected"(val){
            //console.log("selected is changed",val);
            if(val){
                this.$refs.chart1ref.showSeries('series-3');
            }
            else{
                this.$refs.chart1ref.hideSeries('series-3');
            }
            //this.$refs.chart1ref.toggleSeries('series-3');
        },
        "dataLabels"(val){
            if(val){
                this.$refs.chart1ref.updateOptions({
                    dataLabels:{
                        enabled:true
                    }
                })
            }
            else{
                this.$refs.chart1ref.updateOptions({
                    dataLabels:{
                        enabled:false
                    }
                })
            }
            //console.log(this.chartOptions.dataLabels)
        }
    }
};
</script>